import { render, staticRenderFns } from "./listPost.vue?vue&type=template&id=f840058e&scoped=true&"
import script from "./listPost.vue?vue&type=script&lang=js&"
export * from "./listPost.vue?vue&type=script&lang=js&"
import style0 from "./listPost.vue?vue&type=style&index=0&id=f840058e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f840058e",
  null
  
)

export default component.exports